import { UseMutateAsyncFunction, useMutation } from "@tanstack/react-query";
import axios from "axios";

import { DOMAIN_AUTH } from "../domain";

export const ACTION_GENERATE_SSO_TOKEN = "GENERATE_SSO_TOKEN";

const generateSsoToken = async (userId: string): Promise<string> => {
  const response = await axios.post(
    `${import.meta.env.VITE_API_BASE_URL}/auth/sso/generate`,
    {
      userId,
    },
  );

  return response.data.sso_token;
};

export const useGenerateSsoToken = (): {
  generateSsoTokenAsync: UseMutateAsyncFunction<string, Error, string, unknown>;
  isSuccessGenerateSsoToken: boolean;
  isPendingGenerateSsoToken: boolean;
} => {
  const { mutateAsync, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_AUTH, ACTION_GENERATE_SSO_TOKEN],
    mutationFn: generateSsoToken,
  });

  return {
    generateSsoTokenAsync: mutateAsync,
    isSuccessGenerateSsoToken: isSuccess,
    isPendingGenerateSsoToken: isPending,
  };
};
